<template>
  <div>
    <p>Sounds like you're really sensitive to noise! Here are some tips to reducing the noise of your purifier:
    </p>
    <h4>Turn your purifier on low</h4>
    <p>Get yourself a <router-link to="purifiers/diy11">DIY1.1</router-link> or a <router-link to="purifiers/cannon">Cannon</router-link> and turn them on low. Our tests have shown that <a href="https://smartairfilters.com/data/en/#q2">after 1-2 hours of having the purifier on high</a>, the air inside the room should clean. At this point you could turn your DIY1.1 or Cannon to medium or low, and the purifier should be able to maintain the clean level of air.</p>
    <h4>Spend a little extra</h4>
    <p>The <router-link to="purifiers/blast">Blast</router-link> and <router-link to="purifiers/blastmini">Blast Mini</router-link> cost a little more than the DIYs, but they have a huge fan and a huge filter which makes them insanely quiet. Oh, and don't fret, they're still a lot cheaper than most purifiers out there.</p>
</div>
</template>

<script>
import {all} from '@/data/purifiers.js'
import PurifierImage from '@/components/PurifierImage'

export default {
  name: 'Noise',
  components: {PurifierImage},
  props: ['id'],
  computed: {
    purifier: function () {
      console.log(this.id)
      var a = all.filter((i) => {
        return i.id === this.id
      })[0]
      console.log(a)
      return a
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
a h1, a h2, a:hover {
  text-decoration:none;
  color: #2c3e50;
}
img.purifier_img {
  max-width:200px;
}
.backbutton {
  text-align:left;
}
.purifierinfo {
  max-width:400px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/NoiseView.vue